import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  getLayerId,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { wellsFilterProperty } from '@pn/core/storage/workspace/wellsFilterProperty';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_COLOR, DEFAULT_SYMBOL_STYLE } from '@pn/services/styles';
import { setOriginalLayers } from '.';

export const wells: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'wells',
  dataType: 'wells',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Wells',
  description: '925k wells in Canada',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: {
    layers: [
      {
        id: getLayerId('wells', 'wells', 0),
        name: 'Wells',
        type: LayerType.Icon,
        style: {
          ...DEFAULT_SYMBOL_STYLE,
          font: ['petroninja-font font'],
          offset: [0, 0.2],
        },
        source: {
          type: 'vector',
          minzoom: 9,
          maxzoom: 10,
          tiles: [
            isProduction()
              ? 'https://tiles.stackdx.com/wells/{z}/{x}/{y}.pbf'
              : 'https://staging-tiles.stackdx.com/wells/{z}/{x}/{y}.pbf',
          ],
        },
        sourceLayer: 'bottoms',
      },
      {
        id: getLayerId('wells', 'wells', 1),
        name: 'Well Paths',
        type: LayerType.Line,
        style: {
          color: DEFAULT_COLOR,
          width: 1,
        },
        source: {
          type: 'vector',
          minzoom: 9,
          maxzoom: 10,
          tiles: [
            isProduction()
              ? 'https://tiles.stackdx.com/wells/{z}/{x}/{y}.pbf'
              : 'https://staging-tiles.stackdx.com/wells/{z}/{x}/{y}.pbf',
          ],
        },
        sourceLayer: 'horizontals',
        sourceField: 'well_path_geometry',
      },
    ],
    filterProperty: wellsFilterProperty,
  },
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/wells',
    requiredMapDataFields: [
      'internal_id',
      'symbol',
      'geometry',
      'well_path_geometry',
    ],
    requiredTableDataFields: [
      'internal_id',
      'geometry',
      'related_ids',
      'stack_link',
      'surface_latitude',
      'surface_longitude',
      'has_documents',
      'surface_location',
      'licensee',
      'pn_well_status',
    ],
  },
  detailsSource: 'api',
  query: buildQuery({
    id: 'wells',
    dataType: 'wells',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
